/**
 * Common Media Stream Type
 *
 * @internal
 */
export const CmStreamType = {
    /**
     *  All segments are available – e.g., VOD
     */
    VOD: 'v',
    /**
     * Segments become available over time – e.g., LIVE
     */
    LIVE: 'l',
};
//# sourceMappingURL=CmStreamType.js.map